import { render } from "./WrongNetwork.htm?vue&type=template&id=5189c87c&scoped=true"
import script from "./WrongNetwork.js?vue&type=script&lang=js"
export * from "./WrongNetwork.js?vue&type=script&lang=js"

import "./WrongNetwork.scss?vue&type=style&index=0&id=5189c87c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5189c87c"]])

export default __exports__